import React, { useEffect } from "react";
import About from "../components/About/About";
import Contact from "../components/Contact/Contact";
import Hero from "../components/Hero/Hero";
import ReactGA from "react-ga";
import Gallery from "../components/Gallery/Gallery.jsx";
import Tabs from "../components/Tabs/Tabs.jsx"
import HcV from "../components/HCverma/HcV.jsx";
import Community from "../components/Community/Community.jsx"


const Homepage = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  return (
    <>
      <Hero />
      <HcV
        name="Dr. Jane Smith"
        title="Chief AI Researcher"
        organization="TechInnovate Labs"
        imageUrl="/placeholder.svg?height=384&width=384"
        bio="Dr. Jane Smith is a world-renowned AI researcher with over 20 years of experience in machine learning and neural networks. She has published numerous papers in top-tier journals and is a frequent keynote speaker at international tech conferences."
      />
      <About />
      <Tabs />
      <Gallery />
      <Community />
      <Contact />
    </>
  );
};

export default Homepage;
